<template>
	<div class="row background-recovery" style="margin: 0px;overflow-y:hidden;">
		<v-container id="recovery" wrap>
			<v-layout justify-center>
				<v-flex xs12 sm7 md7 lg6 xl5 v-if="flags.normal">
					<v-slide-y-transition>
						<v-card height="95.1vh" v-show="verifyLogin && step == 0">
							<v-container bg fill-height grid-list-md text-xs-center>
								<v-layout wrap align-center>
									<v-flex xs8 offset-xs2>
										<v-img :src="require('@/assets/img/0_Skolable.png')"></v-img>
									</v-flex>
									<v-flex xs8 offset-xs2 v-if="flags.error && !flags.loading">
										<h4>
											<b>{{ $t('recovery.notFound') }}</b>
										</h4>
									</v-flex>
									<v-flex xs8 offset-xs2>
										<h2>
											<b>{{ $t('recovery.title') }}</b>
										</h2>
									</v-flex>
									<v-flex xs8 offset-xs2></v-flex>
									<v-alert
										style="border-radius: 10px;"
										:value="flags.error"
										transition="slide-y-reverse-transition"
										type="error"
									>{{ errors.eMessage }}</v-alert>
									<v-flex xs8 offset-xs2>
										<v-form ref="form" v-model="flags.valid" lazy-validation @submit.prevent="sendRequest">
											<v-flex xs8 offset-xs2>
												<p>{{ $t('recovery.emailInput') }}</p>
												<v-text-field
													v-model="form.email"
													@input="$v.form.email.$touch()"
													@blur="$v.form.email.$touch()"
													:label="$t('recovery.form.email')"
													:error-messages="recoveryErrors"
												></v-text-field>
											</v-flex>
											<v-flex xs8 offset-xs2>
												<v-btn
													:disabled="working.wSendRequest"
													class="gradiente white--text"
													large
													round
													type="submit"
												>{{ $t("recovery.submit") }}</v-btn>
											</v-flex>
										</v-form>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card>
					</v-slide-y-transition>
					<v-slide-y-transition>
						<v-card height="95.1vh" v-show="verifyLogin && step == 1">
							<v-container bg fill-height grid-list-md text-xs-center>
								<v-layout wrap align-center>
									<v-flex xs8 offset-xs2>
										<v-img :src="require('@/assets/img/0_Skolable.png')"></v-img>
									</v-flex>
									<v-flex xs8 offset-xs2 v-if="flags.error && !flags.loading">
										<h4>
											<b>{{ $t("recovery.error.main") }}</b>
										</h4>
									</v-flex>
									<v-flex xs8 offset-xs2>
										<h2>
											<b>{{ $t("recovery.title") }}</b>
										</h2>
									</v-flex>
									<v-flex xs8 offset-xs2>
										<p>{{ $t("recovery.sendedRequest") }}</p>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card>
					</v-slide-y-transition>
				</v-flex>
				<v-flex xs12 sm7 md7 lg6 xl5 v-if="!flags.normal">
					<v-slide-y-transition>
						<v-card height="95.1vh" v-show="verifyLogin && step == 0">
							<v-container bg fill-height grid-list-md text-xs-center>
								<v-layout wrap align-center>
									<v-flex xs8 offset-xs2>
										<v-img :src="require('@/assets/img/0_Skolable.png')"></v-img>
									</v-flex>
									<v-flex xs8 offset-xs2>
										<h2>
											<b>{{ $t("recovery.changePassword") }}</b>
										</h2>
									</v-flex>
									<v-flex xs8 offset-xs2 v-if="flags.error && !flags.loading">
										<h4>
											<b>{{ $t("recovery.notFound") }}</b>
										</h4>
									</v-flex>
									<v-flex xs8 offset-xs2 v-if="!flags.error && !flags.loading">
										<v-form
											ref="form"
											v-model="flags.valid"
											lazy-validation
											@submit.prevent="changePasswordRequest"
										>
											<v-flex xs8 offset-xs2>
												<p>{{ $t("recovery.newPassword") }}</p>
												<v-text-field
													:type="show ? 'text' : 'password'"
													@click:append="show = !show"
													:append-icon="show ? 'visibility' : 'visibility_off'"
													v-model="form2.password"
													@input="$v.form2.password.$touch()"
													@blur="$v.form2.password.$touch()"
													:label="$t('recovery.form.password')"
													:error-messages="recoveryPassword"
												></v-text-field>
											</v-flex>
											<v-flex xs8 offset-xs2>
												<v-text-field
													:type="show ? 'text' : 'password'"
													@click:append="show = !show"
													:append-icon="show ? 'visibility' : 'visibility_off'"
													v-model="form2.passwordC"
													@input="$v.form2.passwordC.$touch()"
													@blur="$v.form2.passwordC.$touch()"
													:label="$t('recovery.form.cPassword')"
													:error-messages="recoveryPasswordConfirm"
												></v-text-field>
											</v-flex>
											<v-flex xs8 offset-xs2>
												<v-btn
													:disabled="working.wSendPasswordRequest || !isValidPassword"
													class="gradiente white--text"
													large
													round
													type="submit"
												>{{ $t("recovery.submit") }}</v-btn>
											</v-flex>
										</v-form>
										<div v-show="!isValidPassword">
											<p>Debe contar con al menos 8 caracteres, una mayúscula y un número</p>
										</div>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card>
					</v-slide-y-transition>
					<v-slide-y-transition>
						<v-card height="95.1vh" v-show="verifyLogin && step == 1">
							<v-container bg fill-height grid-list-md text-xs-center>
								<v-layout wrap align-center>
									<v-flex xs8 offset-xs2>
										<v-img :src="require('@/assets/img/0_Skolable.png')"></v-img>
									</v-flex>
									<v-flex xs8 offset-xs2 v-if="flags.error && !flags.loading">
										<h4>
											<b>{{ $t("recovery.errors.main") }}</b>
										</h4>
									</v-flex>
									<v-flex xs8 offset-xs2>
										<h2>
											<b>{{ $t("recovery.changePassword") }}</b>
										</h2>
									</v-flex>
									<v-flex xs8 offset-xs2>
										<p>{{ $t("recovery.passwordUpdated") }}</p>
									</v-flex>
									<v-flex xs8 offset-xs2>
										<v-btn class="gradiente white--text" large round to="/login">{{ $t("recovery.login") }}</v-btn>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card>
					</v-slide-y-transition>
				</v-flex>
			</v-layout>
			<warning v-model="toast.warning" :description="$t('recovery.errors.eEmailInvalid')" :title="$t('recovery.errors.title')"/>
		</v-container>
	</div>
</template>

<script>
	import { required, email, sameAs } from "vuelidate/lib/validators";
	import error from "../Dialogs/Error";
	import warning from "../Dialogs/Alert";
	export default {
		components:{
			error,
			warning
		},
		validations: {
			form: {
				email: { required, email }
			},
			form2: {
				password: { required },
				passwordC: { required, sameAsPassword: sameAs("password") }
			}
		},
		data: () => ({
			step: 0,
			show: false,
			verifyLogin: false,
			isValidPassword: false,
			flags: {
				normal: false,
				loading: false,
				valid: false,
				error: false
			},
			errors: {
				eSendRequest: false,
				eMessage: ""
			},
			form: {
				email: ""
			},
			form2: {
				password: "",
				passwordC: ""
			},
			working: {
				wSendRequest: false,
				wSendPasswordRequest: false
			},
			toast: {
				warning: false,
			},
		}),
		beforeMount: function() {
			if (this.getUriVars == null) {
				this.flags.normal = true;
			}
		},
		mounted() {
			if (this.isLoggedIn) {
				this.$router.push("/panel/home");
			}
			if (this.$accessToken == null) {
				this.verifyLogin = true;
			}
			if (!this.flags.normal) {
				this.verifyCode();
			}
		},
		methods: {
			sendRequest() {
				this.$v.$touch();
				if (!this.$v.form.$invalid) {
					this.flags.loading = true;
					this.working.wSendRequest = true;
					let body = {
						email: this.form.email
					};
					body = Object.keys(body)
						.map(function(k) {
							return encodeURIComponent(k) + "=" + encodeURIComponent(body[k]);
						})
						.join("&");
					this.$store
						.dispatch("login/sendRecoveryRequest", body)
						.then(response => {
							if (response.data.status) {
								this.step++;
								this.flags.loading = false;
								this.working.wSendRequest = false;
							} else {
								this.flags.loading = false;
								this.working.wSendRequest = false;
								this.toast.warning = true;
							}
						})
						.catch(error => {
							this.working.wSendRequest = false;
							this.flags.loading = false;
						});
				}
			},
			changePasswordRequest() {
				this.$v.$touch();
				if (!this.$v.form2.$invalid) {
					this.flags.loading = true;
					this.working.wSendPasswordRequest = true;
					var body = {
						pass: this.form2.password,
						passv: this.form2.passwordC,
						code: this.getUriVars.code
					};
					body = Object.keys(body)
						.map(function(k) {
							return encodeURIComponent(k) + "=" + encodeURIComponent(body[k]);
						})
						.join("&");
					console.log(body);
					this.$store
						.dispatch("login/changePasswordRequest", body)
						.then(response => {
							if (response.data.status) {
								this.step++;
								this.flags.loading = false;
								this.working.wSendPasswordRequest = false;
							} else {
								this.flags.loading = false;
								this.working.wSendPasswordRequest = false;
							}
						})
						.catch(error => {
							this.working.wSendPasswordRequest = false;
							this.flags.loading = false;
						});
				}
			},
			verifyCode() {
				if (this.getUriVars.code != null) {
					this.flags.loading = true;
					var body = {
						code: this.getUriVars.code
					};
					body = Object.keys(body)
						.map(function(k) {
							return encodeURIComponent(k) + "=" + encodeURIComponent(body[k]);
						})
						.join("&");
					this.$store
						.dispatch("login/verifyCode", body)
						.then(response => {
							this.flags.loading = false;
							if (!response.data.status) {
								this.flags.error = true;
								console.log(response);
							}
						})
						.catch(error => {
							this.flags.loading = false;
							this.flags.error = true;
						});
				}
			}
		},
		computed: {
			recoveryErrors() {
				const errors = [];
				if (!this.$v.form.email.$dirty) return errors;
				!this.$v.form.email.email &&
					errors.push(this.$t("recovery.errors.eEmailInvalid"));
				!this.$v.form.email.required &&
					errors.push(this.$t("recovery.errors.eEmailRequired"));
				return errors;
			},
			recoveryPassword() {
				const errors = [];
				if (!this.$v.form2.password.$dirty) return errors;
				!this.$v.form2.password.required &&
					errors.push(this.$t("recovery.errors.ePasswordRequired"));
				return errors;
			},
			recoveryPasswordConfirm() {
				const errors = [];
				if (!this.$v.form2.passwordC.$dirty) return errors;
				!this.$v.form2.passwordC.required &&
					errors.push(this.$t("recovery.errors.eConfirmPasswordRequired"));
				!this.$v.form2.passwordC.sameAsPassword &&
					errors.push(this.$t("recovery.errors.ePasswordsMatch"));
				return errors;
			},
			getUriVars() {
				let uri = window.location.href.split("?");
				if (uri.length == 2) {
					let vars = uri[1].split("&");
					let getVars = {};
					let tmp = "";
					vars.forEach(function(v) {
						tmp = v.split("=");
						if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
					});
					console.log(getVars);
					return getVars;
				}
				return null;
			}
		},
		watch:{
			'form2.password':function () {
				const minPasswordLength = 8;
				const regexContainsANumber = new RegExp(/[0-9]/g);
				const regexContainsACapitalLetter = new RegExp(/[A-Z]/g);

				const isMinPasswordLength = this.form2.password.length >= minPasswordLength;
				const containsPasswordANumber = regexContainsANumber.test(this.form2.password)
				const containsPasswordACapital = regexContainsACapitalLetter.test(this.form2.password)

				if (isMinPasswordLength && containsPasswordANumber && containsPasswordACapital) {
					this.isValidPassword = true;
					return;
				}
				
				this.isValidPassword = false;
			}
		}
	};
</script>

<style>
	.background-recovery {
		background: url(../../assets/recovery/qrRegister.png) no-repeat center center
			fixed;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}
</style>
